import wechat from './wxShare';
import { shareConfig } from '@/api/api';
export default {
  install(Vue) {
    Vue.prototype.$wxShare = function (title, desc, img) {
      shareConfig({
        url: location.href,
        userId: 239,
        typeId: 1,
        key: 1430
      }).then(res => {
        const wxConfigData = res.data
        wechat.share(
          wxConfigData,
          title,
          desc,
          img,
          location.href
        );
      })
    }
    Vue.prototype.$handleUnit = function (num) {
      if (num >= 1000 && num < 10000) {
        return (num / 1000).toFixed(1) + 'k'
      } else if (num >= 10000) {
        return (num / 10000).toFixed(1) + 'w'
      } else {
        return num
      }
    }
  }
}
